import React, {Component} from "react";
import {PaymentMethod} from "../../../http/protocol";
import "./styles/PaymentProviderButton.scss";
import getPaymentMethodIcon, {getPaymentMethodIconByCode} from "../GetPaymentMethodIcon";
import { t } from "../../../i18n";


const Item = (props : {method : PaymentMethod, onClick? : (m : PaymentMethod, group?: boolean) => void }) => {
    let code = props.method.code;
    let group = false;
    if(props.method.group) {
        group = true;
        code = props.method.group;
    }
    return (
        <div onClick={()=>{props.onClick&& props.onClick(props.method, group)}} className={"dropdownItem"}>
            {props.method.code &&
                <div className={"item"}>
                    <img alt={"method icon"}  className={"img method-"+props.method?.code?.toLowerCase()} />
                    <div className={"text"}>
                        {t(`payments.method.${code}.name`, undefined, props.method.name)}
                    </div>
                </div>
            }
        </div>
    )
}

export default Item;